module.exports = __webpack_public_path__ + "img/545559b.jpg";